




















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
import {TranslateResult} from 'vue-i18n';
import {min, required} from 'vee-validate/dist/rules';

extend('required', required);
extend('min', min);

@Component({
  name: 'catalog-product-review-form',
  components: {
    ValidationObserver,
    ValidationProvider
  }
})

export default class extends Vue {
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  }

  @Prop({required: false}) private productId: string;
  @Prop({required: false}) private orderId: string;
  @Prop({required: false}) private productName: string;

  private showReviewForm: boolean = false;
  private savedReview: boolean = false;
  private review: object = {
    title: null,
    nickname: null,
    message: null,
    rating: null,
    ordernumber: null,
  };

  private serviceUrl: object = {
    nl_NL: '/klantenservice',
    nl_BE: '/klantendienst'
  };

  private hasError: boolean = false;
  private errorMessage: TranslateResult = '';

  private async submitForm(): Promise<void> {
    this.hasError = false;
    if (await this.$refs.form.validate()) {
      try {
        const {data} = await this.$solarClient.post(`api/catalog/product/${this.productId}/review`, this.review);

        if (data.hasOwnProperty('status')) {
          this.hasError = true;
          this.errorMessage = data['message'];
        }

        this.review = {
          title: null,
          nickname: null,
          message: null,
          rating: null,
          ordernumber: null,
        };

        this.$refs.form.reset();

        this.showReviewForm = false;
        this.savedReview = true;
      } catch (err) {
        this.hasError = true;
        if (err.hasOwnProperty('response') && err.response.data.hasOwnProperty('message')) {
          this.errorMessage = err.response.data['message'];
        } else {
          this.errorMessage = this.$t('Unable to place review');
        }
      }
    }
  }
  private created(): void {
    console.log(this.productId, this.orderId);
    if (this.orderId) {
      this.review['ordernumber'] = this.orderId;
    }
  }
}
